$(function () {

    let WINSLOVE = {
        script: {
            init: function () {
                this.heroSlider();
                this.menu();
            },

            menu: function() {
                jQuery('.navbar-toggler').on('click', function () {
                    var checkAttr = jQuery(this).attr('aria-expanded');

                    if(checkAttr === 'true') {
                        jQuery('body').removeClass('overflow-hidden');
                    }else {
                        jQuery('body').addClass('overflow-hidden');
                    }


                });
            },

            heroSlider: function () {
                jQuery('.heroSlider').slick({
                    infinite: true,
                    autoplay: false,
                    slidesToShow: 1,
                    fade: true,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: false,
                });
            },

        },
    };

    jQuery(function() {
        WINSLOVE.script.init();
    });
});